import * as yup from 'yup'
import {
  REQUIRED_FIELD,
  REQUIRED_INCOME,
  ERROR_INCOME_OVER_ONE,
  ERROR_NOT_A_NUMBER,
  ERROR_IN_GOOD_CONSCIENCE,
  FINANCIAL_REMARKS_MAX_LENGTH,
} from './../constants'

export default yup
  .object({
    financialRemarks: yup.string().max(FINANCIAL_REMARKS_MAX_LENGTH),
    inGoodConscience: yup.boolean().when('isIncomeRequired', {
      is: true,
      then: schema => schema.required(ERROR_IN_GOOD_CONSCIENCE).oneOf([true], ERROR_IN_GOOD_CONSCIENCE),
    }),

    // acceptDataUsages: yup.boolean().when(['inModal', 'isFirstPhase'], {
    //   is: (inModal, isFirstPhase) => {
    //     return inModal === undefined && isFirstPhase === undefined ? false : !inModal && isFirstPhase
    //   },
    //   then: yup
    //     .boolean()
    //     .required(ERROR_ACCEPT_DATA_USAGE)
    //     .oneOf([true], ERROR_ACCEPT_DATA_USAGE),
    // }),
    incomeStatement: yup.string().when(['inModal', 'isFirstPhase', 'shouldIncludeIncomeStatement'], {
      is: (inModal, isFirstPhase, shouldIncludeIncomeStatement) => {
        if (!shouldIncludeIncomeStatement) {
          return false
        }
        if (inModal === undefined && isFirstPhase === undefined) {
          return false
        }
        return !inModal && isFirstPhase
      },
      then: yup.string().required(ERROR_IN_GOOD_CONSCIENCE),
    }),
    contacts: yup.array(
      yup.object({
        firstname: yup.string().required(REQUIRED_FIELD),
        lastname: yup.string().required(REQUIRED_FIELD),
        hasReleventIncome: yup.boolean(),
        isIncomeRequired: yup.boolean(),
        income: yup.array().when(['hasReleventIncome', 'isIncomeRequired'], {
          is: (hasReleventIncome, isIncomeRequired) => {
            if (!isIncomeRequired) {
              return false
            }
            return hasReleventIncome === undefined || hasReleventIncome == true
          },
          then: yup
            .array()
            .min(1, REQUIRED_INCOME)
            .of(
              yup.object({
                value: yup
                  .number()
                  .typeError(ERROR_NOT_A_NUMBER)
                  .min(1, ERROR_INCOME_OVER_ONE),
              }),
            ),
        }),
      }),
    ),
  })
  .transform(function(value, originalvalue) {
    return {
      ...originalvalue,
      contacts: originalvalue.contacts.map(contact => ({
        ...contact,
        isIncomeRequired: originalvalue.isIncomeRequired,
      })),
    }
  })



// WEBPACK FOOTER //
// ./src/utils/validation/schemas/incomeSchema.js